











































import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({})
export default class extends Vue {
  @Prop({ default: () => [] })
  suggestionList!: {
    id: number
    name: string
    avatar: string
  }[]
  @Prop({ default: false })
  isLoading!: boolean

  public noAvatar = require('@/assets/images/avatar-default.png')

  onSelectSuggestion(event: any, suggestion: any) {
    this.$emit('onSelectSuggestion', { event, suggestion })
  }
}
